<div class="w-100 d-flex justify-content-start justify-content-md-center mt-3 mb-4 overflow-x-scroll">

  <div class="d-flex align-items-center px-5 cursor-pointer hover-text" (click)="setStep(1)">
    <div class="ratio ratio-1x1 p-4 me-2 text-primary">
      <div class="rounded-circle d-flex justify-content-center align-items-center border border-primary" [class.bg-primary]="step===1" [class.text-white]="step===1">
        1
      </div>
    </div>
    Parametry
  </div>

  <div *ngIf="calculation; else noCalculationSecondStep" class="d-flex align-items-center px-5 cursor-pointer hover-text" (click)="setStep(2)">
    <div class="ratio ratio-1x1 p-4 me-2 text-primary">
      <div class="rounded-circle d-flex justify-content-center align-items-center border border-primary" [class.bg-primary]="step===2" [class.text-white]="step===2">
        2
      </div>
    </div>
    Kalkulace
  </div>

  <ng-template #noCalculationSecondStep>
    <div class="d-flex align-items-center px-5 text-secondary">
      <div class="ratio ratio-1x1 p-4 me-2 text-secondary">
        <div class="rounded-circle d-flex justify-content-center align-items-center border border-secondary" [class.bg-primary]="step===2" [class.text-white]="step===2">
          2
        </div>
      </div>
      Kalkulace
    </div>
  </ng-template>


  <div *ngIf="calculation; else noCalculationThirdStep" class="d-flex align-items-center px-5 cursor-pointer hover-text" (click)="setStep(3)">
    <div class="ratio ratio-1x1 p-4 me-2 text-primary">
      <div class="rounded-circle d-flex justify-content-center align-items-center border border-primary" [class.bg-primary]="step===3" [class.text-white]="step===3">
        3
      </div>
    </div>
    Zákazník
  </div>

  <ng-template #noCalculationThirdStep>
    <div class="d-flex align-items-center px-5 text-secondary">
      <div class="ratio ratio-1x1 p-4 me-2 text-secondary">
        <div class="rounded-circle d-flex justify-content-center align-items-center border border-secondary" [class.bg-primary]="step===3" [class.text-white]="step===3">
          3
        </div>
      </div>
      Zákazník
    </div>
  </ng-template>

  <div *ngIf="calculation; else noCalculationFourthStep" class="d-flex align-items-center px-5 cursor-pointer hover-text" (click)="setStep(4)">
    <div class="ratio ratio-1x1 p-4 me-2 text-primary">
      <div class="rounded-circle d-flex justify-content-center align-items-center border border-primary" [class.bg-primary]="step===4" [class.text-white]="step===4">
        4
      </div>
    </div>
    Podklady
  </div>

  <ng-template #noCalculationFourthStep>
    <div class="d-flex align-items-center px-5 text-secondary">
      <div class="ratio ratio-1x1 p-4 me-2 text-secondary">
        <div class="rounded-circle d-flex justify-content-center align-items-center border border-secondary" [class.bg-primary]="step===4" [class.text-white]="step===4">
          4
        </div>
      </div>
      Podklady
    </div>
  </ng-template>

  <div class="d-flex align-items-center px-5 text-secondary">
    <div class="ratio ratio-1x1 p-4 me-2 text-secondary">
      <div class="rounded-circle d-flex justify-content-center align-items-center border border-secondary" [class.bg-primary]="step===5" [class.border-secondary]="step!==5" [class.border-primary]="step===5" [class.text-white]="step===5">
        5
      </div>
    </div>
    Dokončení
  </div>

</div>


<app-first-step *ngIf="step===1" (calculation)="updateCalculation($event)" (change)="restartAfterChange()"></app-first-step>
<app-second-step *ngIf="step===2" [calculation]="calculation" (addCustomer)="next()"></app-second-step>
<app-third-step *ngIf="step===3" [calculation]="calculation" (finish)="next()"></app-third-step>
<app-fourth-step  *ngIf="step===4" [calculation]="calculation" (finish)="finish()"></app-fourth-step>
<app-fifth-step  *ngIf="step===5" (finish)="restart()"></app-fifth-step>
